import React from "react";
import { T } from "../theme";
import { Btn, TapeIcon } from "../ui";

export default function SplashScreen({ onDone }) {
  return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: T.font, padding: 32 }}>
      <div style={{ position: "relative", marginBottom: 24 }}>
        <TapeIcon size={110} color="#E8D4A8" accent="#C45A2D" />
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(circle,rgba(217,164,65,0.15) 0%,transparent 70%)", borderRadius: "50%" }} />
      </div>
      <div style={{ fontSize: 32, fontWeight: "bold", color: T.text, letterSpacing: "0.06em", textAlign: "center", lineHeight: 1.1 }}>8TRACK<br />VAULT</div>
      <div style={{ fontSize: 12, color: T.muted, letterSpacing: "0.22em", textTransform: "uppercase", marginTop: 6, marginBottom: 40 }}>Preserve the Sound.</div>
      <Btn onClick={onDone} style={{ width: "100%", padding: 14, fontSize: 14 }}>Get Started</Btn>
    </div>
  );
}
